module.exports = __webpack_public_path__ + "img/surprise.acc9d05e.svg";